import { render, staticRenderFns } from "./OrderSubmission.vue?vue&type=template&id=09738342&scoped=true"
import script from "./OrderSubmission.vue?vue&type=script&lang=js"
export * from "./OrderSubmission.vue?vue&type=script&lang=js"
import style0 from "./OrderSubmission.vue?vue&type=style&index=0&id=09738342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09738342",
  null
  
)

export default component.exports